const config = {
    throttleTimeout: 300,
    breakpoints: {
        xl: 1200,
        lg: 992,
        md: 768,
        sm: 575
    },
    fixedHeaderPixels: 175
};

export default config;



// WEBPACK FOOTER //
// ./config.js